<template>
  <ModalDialog
    ref="dialog"
    title="Cancel Credit Note"
    icon="fa-times-circle"
    :showFooter="true"
    :submitting="submitting"
    closeTitle="Cancel"
    submitTitle="Update"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="form" :labelColumnSize="3">
      <NotificationBar type="warning">
        <NotificationBarTitle>This will cancel the credit note and cannot be undone</NotificationBarTitle>
        <ul>
          <li>All invoice allocations will be cancelled and any paid invoices will be reverted to unpaid</li>
        </ul>
        <template v-if="hasXeroIntegration">
          <strong>Xero Users</strong>
          <ul>
            <li>After cancelling, please access Xero to ensure credit notes and any invoice allocations linked to this credit note have been cancelled too.</li>
          </ul>
        </template>
        
      </NotificationBar>
      
      <FormRow label="Cancellation Reason">
        <FormInputTextArea ref="textEntryArea" v-model="cancelReason" placeholder="Enter reason and details for credit note cancellation" field="reason" />
      </FormRow>
      
    </FormGroup>
  </ModalDialog>
</template>

<style scoped>

</style>

<script>
import _ from 'lodash'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: 'CreditNoteCancelDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    creditNoteId: Number
  },
  data() {
    return {
      form: {},
      submitting: false,
      cancelReason: ''
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    show() {
      this.form = {}
      this.submitting = false

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.form = this.clearFormResponse()
      this.submitting = true

      var updateData = {
        reason: this.cancelReason
      }

      this.$apiService.accountsService.cancelCreditNote(this.creditNoteId, updateData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.form = this.processFormResponse(err)
      })
      .finally(() => {
        this.submitting = false
      })
    }
  }
}
</script>